export default __webpack_public_path__ + "static/media/circulationSmall.de972ef1.jpg";